import $ from 'jquery';
import RTE from '../globals/RTE';

export default class StaticArticle {
  constructor(section) {
    const { el } = section;
    this.$articleWrapper = $('[data-article-wrapper]', el);
    this.$articleImage = $('[data-article-image]', el);
    this.rte = new RTE(el.querySelector('.rte'));

    this._positionImage();

    $(window).on('resize.article', () => this._positionImage());
  }

  onSectionMessage(name) {
    if (name === 'header:repositionedNav') {
      this._positionImage();
    }
  }

  _positionImage() {
    this.$articleImage
      .css('top', this.$articleWrapper.offset().top)
      .addClass('article-image-positioned');
  }

  onSectionUnload() {
    $(window).off('resize.article');
    this.rte.unload();
  }
}
